export default "__VITE_ASSET__0xCeG3KJ__"